var pic1 = require('../../assets/images/facility/classroom/room1.jpg');
var pic2 = require('../../assets/images/facility/classroom/room2.jpg');
var pic3 = require('../../assets/images/facility/classroom/room3.jpg');
var pic4 = require('../../assets/images/facility/classroom/room4.jpg');
var pic5 = require('../../assets/images/facility/classroom/room5.jpg');
const DataGalleryFacilityRooms = [
 {    
	id: 1,
	title:"Office Room",
    image: pic1,	    
	alt  :"Office Room",
  },
  {    
	id: 2,
	title: "Class Room",
    image: pic2,	    
	alt: "Class Room",
  },
  {    
	id: 3,
	title: "Computer Lab",
    image: pic3,	    
	alt: "Computer Lab",
  },
  {    
	id: 4,
	title: "Self Study Room",
    image: pic4,	    
	alt: "Self Study Room",
  },
  {    
	id: 5,
	title: "Community Room",
    image: pic5,	    
	alt: "Community Room",
  },
];
export default DataGalleryFacilityRooms;